import { Button, useRecordContext, useUpdate, useNotify, useRefresh } from 'react-admin';
import { AssignmentInd as AssignIcon } from '@mui/icons-material';

export const AssignButton = () => {
  const record = useRecordContext();
  const [update, { isLoading }] = useUpdate();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record) return null;

  const handleAssign = () => {
    // TODO: Get current admin user ID from auth context
    // For now, use placeholder - backend will extract from JWT token
    const currentAdminId = 1;

    update(
      'support/tickets',
      {
        id: record.id,
        data: { assigned_to: currentAdminId },
        previousData: record
      },
      {
        onSuccess: () => {
          notify('Ticket assigned to you', { type: 'success' });
          refresh();
        },
        onError: () => {
          notify('Error assigning ticket', { type: 'error' });
        }
      }
    );
  };

  if (record.assigned_to) {
    return null; // Already assigned
  }

  return (
    <Button
      label="Assign to Me"
      onClick={handleAssign}
      disabled={isLoading}
    >
      <AssignIcon />
    </Button>
  );
};
